import dynamic from 'next/dynamic';
import React from 'react';

const Callback = dynamic(() => import('@members/pg-auth/Callback'), {
  ssr: false,
});

export default function CallbackPage() {
  return <Callback />;
}
